import styles from '../globals/pages.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { apiErrors } from '../helpers/apiErrors'
import HearingLossSignForm from '../components/hearingLossSignForm/main'
import { useUpdateClaimData } from '../claimProvider'

function SignHearingLoss() {
    const [claimLoaded, setClaimLoaded] = useState(false)
    const [requesting, setRequesting] = useState(false)
    const { caseRef } = useParams()
    const updateClaim = useUpdateClaimData()

    useEffect(() => {
        if (requesting || claimLoaded) return
        if (!caseRef) {
            apiErrors('unknown')
            return
        }

        if (process.env.REACT_APP_MOCK_CLAIM === 'true') {
            updateClaim({
                caseRef,
                claimType: 'limitation',
                documentUrl: 'https://pdfobject.com/pdf/sample.pdf',
                clientName: 'John Smith',
                clientEmail: 'john.smith@example.com',
            })
            setClaimLoaded(true)
            return
        }

        setRequesting(true)
        Loading.circle('Loading your document')

        axios
            .get(`${process.env.REACT_APP_API_TOKEN_URL}/mhl-esign/${caseRef}`)
            .then((response) => {
                Loading.remove()
                if (response.data?.error === 'Already signed') {
                    Report.success('Document Signed', 'Your document has already been signed.', 'Okay', () => {
                        window.location.href = 'https://sentinellegal.co.uk'
                    })
                    return
                }
                const data = response.data?.sigData
                if (data) {
                    const documents = Array.isArray(data.documents)
                        ? data.documents
                        : Array.isArray(response.data?.documents)
                          ? response.data.documents
                          : []
                    updateClaim({
                        caseRef: data.case_ref,
                        token: data.token,
                        claimType: data.is_limitation ? 'limitation' : 'non-limitation',
                        documentUrl: data.doc_url || documents[0]?.url,
                        documents,
                        first_name: data.first_name || '',
                        last_name: data.last_name || '',
                        clientEmail: data.email,
                        matrixChoiceEnabled: data.matrixChoiceEnabled === true,
                    })
                    setClaimLoaded(true)
                } else {
                    throw new Error('Failed to load claim')
                }
            })
            .catch((e) => {
                Loading.remove()
                if (e.response) {
                    apiErrors(e.response.data)
                } else {
                    apiErrors('unknown')
                }
            })
    }, [caseRef, requesting, claimLoaded, updateClaim])

    return <div className={`${styles.pcpClaimFormContainer}`}>{claimLoaded && <HearingLossSignForm />}</div>
}

export default SignHearingLoss
